import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateApi } from "../../../../api/api";
import { toast } from "sonner";

// Tipe untuk data yang diterima oleh fungsi mutasi
interface ImportBookingPayload {
    propertyId: string;
    file: File;
}

/**
 * Custom hook untuk mengimpor file booking Excel.
 */
export const useImportBooking = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ propertyId, file }: ImportBookingPayload) => {
            // Gunakan FormData untuk mengirim file
            const formData = new FormData();
            formData.append('property_id', propertyId);
            formData.append('file', file);

            // Panggil API dengan FormData
            return await privateApi.post('/v4/booking-import', formData, {
                headers: {
                    // Pastikan header diatur untuk multipart/form-data
                    'Content-Type': 'multipart/form-data',
                },
            });
        },
        onSuccess: () => {
            // Invalidate query 'bookings' untuk me-refresh tabel reservasi
            queryClient.invalidateQueries({ queryKey: ['bookings'] });
            toast.success("File imported successfully! The reservation list will be updated shortly.");
        },
        onError: (error: any) => {
            // Tampilkan pesan error yang lebih spesifik jika ada
            const errorMessage = error?.response?.data?.message || "Failed to import file.";
            const errors = error?.response?.data?.errors;

            // Jika ada detail error (misal, error per baris), tampilkan
            if (errors) {
                const detailMessage = Object.values(errors).flat().join(' ');
                toast.error(`${errorMessage}: ${detailMessage}`);
            } else {
                toast.error(errorMessage);
            }
        }
    });
};